export default __webpack_public_path__ + "static/media/TL01.7e67eab2.mp3";